import { IUser } from 'exchange-common'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { IState } from 'src/models/state'

export const HeaderAccount = () => {

	const headerAvatar = require('../images/avatar-bg.svg')
	const logout = require('../images/logout.svg')

	const user = useSelector<IState, IUser>((state) => state.user)

	return user.isLogged ? (
		<div className='headerAccount'>
			<div className='headerProfile'>
				<div className='headerProfileBox'>
					<span className='headerProfileName'>{user.nickname || user.email}</span>
					<img src={headerAvatar} className='headerAvatar' alt='headerAvatar' />
					<span className='profileArrowDown' />
				</div>
				<div className='profileDropdown'>
					<Link className='profileDropdownItem' to='/logout'><img src={logout} className='icon' alt='logout' /><span>Logout</span></Link>
				</div >
			</div>
		</div>
	) : (
			<div className='headerLogin' />
		)
}



// WEBPACK FOOTER //
// ./src/components/headerAccount.tsx